import {useCallback, useEffect, useState} from "react";
import {listLicencas} from "./LicencasService";
import {getBackendMessage, normalizeLicencaRows} from "./licencasUtils";

// As assinaturas, de 100 em 100, para o dashboard de licenças. A gestão fica na lista de assinaturas (BBF-147).
export const useLicencas = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState({error: '', success: ''});

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const itens = [];
            for (let page = 1; page <= 20; page += 1) {
                const data = (await listLicencas({page, pageSize: 100, sortBy: 'criado_em', order: 'desc'}))?.data?.data || {};
                itens.push(...(data.items || []));
                if (!data.pagination?.has_next) break;
            }
            setRows(normalizeLicencaRows(itens));
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar as licenças.'), success: ''});
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return {rows, loading, feedback, setFeedback, reload: load};
};
